import { Component, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { OpbCompanyFormComponent } from '../opb-company-form/opb-company-form.component';
import { HasUnsavedChanges } from '../../../guards/unsaved-changes.guard';

@Component({
  selector: 'app-opb-company-create',
  imports: [
    OpbCompanyFormComponent,
    NgxSpinnerModule
  ],
  templateUrl: './opb-company-create.component.html',
  styleUrl: './opb-company-create.component.scss'
})
export class OpbCompanyCreateComponent implements HasUnsavedChanges {
  @ViewChild(OpbCompanyFormComponent) companyForm?: OpbCompanyFormComponent;

  private router = inject(Router);

  hasUnsavedChanges(): boolean {
    return this.companyForm?.hasUnsavedChanges() ?? false;
  }

  onCancel(): void {
    this.router.navigate(['/companies', 'opb-list']);
  }
}
